import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import TenderContent from "./TenderContent";

const VideoBgSection = () => {
  const contentRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const scrollToSection = () => {
      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };
    scrollToSection();
  }, [location]);

  return (
    <section id="tenders" ref={contentRef} className="relative mt-6">
      {/* Background Video */}
      <div className="absolute inset-0 z-0 opacity-40 overflow-hidden">
        <video
          className="h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/img/bg_video.mp4" type="video/mp4" />
          Your browser is not supported!
        </video>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10 flex items-center justify-center h-full sm:h-auto">
        <TenderContent />
      </div>
    </section>
  );
};

export default VideoBgSection;
